import React, { useState } from "react";
import "./AsideBar.css";
import { Icon } from "@iconify/react";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
function AsideBar() {
  const [submenu, Showsubmenu] = useState(false);
  const [submenu1, Showsubmenu1] = useState(false);
  const [sidemenu, showSideMenu] = useState(true);
  const handleFilter = () => {
    const filterDiv = document.getElementById("for-filer-hide");
    filterDiv.classList.toggle("activeF");
    const filterCol = document.getElementById("filter-col");
    filterCol.classList.toggle("coloumn-big");
    const rightColoum = document.getElementById("card-col");
    rightColoum.classList.toggle("for-right-adjustment");
    // filterDiv.style.transition = "1s ease-in-out";

    if (filterDiv.style.left === "0px") {
      filterDiv.style.left = "-500px";
    } else {
      filterDiv.style.left = "0px";
    }
  };
  return (
    <div>
      <section className="aside-bar">
        <div className="aside-bar-content">
          <div className="aside-filter py-3 menu " onClick={handleFilter}>
            <Icon
              className="filter-ico-tet"
              icon="clarity:filter-grid-line"
              height={48}
              color="white"
            />
            <Icon
              icon="ep:arrow-up-bold"
              rotate={3}
              height={24}
              color="white"
              className="arrow-ico-tet"
            />
          </div>

          <div id="for-filer-hide" className="mystyle">
            <div className="aside-title ">
              <p>Buy now</p>
              <Form>
                <Form.Check type="switch" id="custom-switch" />
              </Form>
            </div>

            <div className="aside-title d-flex flex-column">
              <div
                onClick={() => {
                  submenu ? Showsubmenu(false) : Showsubmenu(true);
                }}
                className=" d-flex justify-content-between w-100"
              >
                <p>Price</p>
                <Icon
                  icon="ep:arrow-up-bold"
                  rotate={submenu ? 4 : 2}
                  height={24}
                  color="white"
                  className="show"
                />
              </div>
              {submenu && (
                <div className="sub-menu mt-2">
                  <p>ETH</p>
                  <div
                    id="submenu"
                    className="d-flex justify-content-between align-items-center"
                  >
                    <input type="number" placeholder="130" name="" id="" />
                    <span>-</span>
                    <input type="number" placeholder="130" name="" id="" />
                  </div>
                  <button>Apply</button>
                </div>
              )}
            </div>

            <div className="aside-title  d-flex flex-column">
              <div
                className=" d-flex justify-content-between w-100"
                onClick={() => {
                  submenu1 ? Showsubmenu1(false) : Showsubmenu1(true);
                }}
              >
                <p>Background</p>
                <Icon
                  icon="ep:arrow-up-bold"
                  rotate={submenu1 ? 4 : 2}
                  height={24}
                  color="white"
                  className="show arr"
                  onClick={Showsubmenu1}
                />
              </div>
              {submenu1 && (
                <div className="sub-menu2 mt-2">
                  <div className="searchbox">
                    <Icon
                      icon="ant-design:search-outlined"
                      color="white"
                      width="24"
                      height="24"
                    />
                    <input type="search" placeholder="Type here" />
                  </div>
                  <div className="bg-items  mt-2">
                    <div className="item-name dfb">
                      <p>Sunset Pearl</p>
                      <p>
                        <span>126</span> /1000
                      </p>
                    </div>
                    <div className="item-token mt-2 dfb">
                      <p>5.56 Token</p>
                      <p>1.26%</p>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="aside-title ">
              <p>Clothing</p>
              <Icon
                icon="ep:arrow-up-bold"
                rotate={2}
                height={24}
                color="white"
                className="arr"
              />
            </div>

            <div className="aside-title ">
              <p>Eyes</p>
              <Icon
                icon="ep:arrow-up-bold"
                rotate={2}
                height={24}
                color="white"
                className="arr"
              />
            </div>

            <div className="aside-title ">
              <p>Eyewear</p>
              <Icon
                icon="ep:arrow-up-bold"
                rotate={2}
                height={24}
                color="white"
                className="arr"
              />
            </div>

            <div className="aside-title ">
              <p>Fur</p>
              <Icon
                icon="ep:arrow-up-bold"
                rotate={2}
                height={24}
                color="white"
                className="arr"
              />
            </div>

            <div className="aside-title ">
              <p>Headwear</p>
              <Icon
                icon="ep:arrow-up-bold"
                rotate={2}
                height={24}
                color="white"
                className="arr"
              />
            </div>

            <div className="aside-title ">
              <p>Mouth</p>
              <Icon
                icon="ep:arrow-up-bold"
                rotate={2}
                height={24}
                color="white"
                className="arr"
              />
            </div>

            <div className="aside-title ">
              <p>Tech</p>
              <Icon
                icon="ep:arrow-up-bold"
                rotate={2}
                height={24}
                color="white"
                className="arr"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AsideBar;
